import React from "react";
import { render } from "react-dom";
import VenueFinder from "./app/VenueFinder";


render(
  <VenueFinder/>
  ,
  document.getElementById("app")
);
